import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: ' ',
  },
  {
    displayName: 'Dashboard',
    iconName: 'home',
    matIconName: 'home',
    route: '/dashboard',
  },


  {
    displayName: 'PSA con giudizio emesso',
    iconName: 'box-multiple',
    matIconName: 'description',
    route: '/gestione-psa/lista-psa',

  },



];
